import { Text } from '@components/primitives/Text'
import { classMerge } from '@components/utilities/classMerge'
import type { TextColor } from '@lib/colors/colors'
import { type ReactNode } from 'react'
import { getColumnWidth } from './utils'

export const Table = ({
  borderClass = 'border-neutral200',
  clampContent = false,
  className,
  columnClassName,
  headerBackground = 'bg-linearPrimary',
  headerRow,
  rows,
  textAlignment = 'text-center',
  textColor = 'text-white',
}: {
  borderClass?: string
  clampContent?: boolean
  className?: string
  columnClassName?: string
  headerBackground?: string
  headerRow: ReactNode[]
  rows: ReactNode[][]
  textAlignment?: 'text-left' | 'text-center'
  textColor?: TextColor
}) => {
  const totalColumns = headerRow.length

  return (
    <div
      className={`w-full border bg-white ${borderClass} overflow-hidden rounded-2xl`}
    >
      <div className='overflow-auto md:overflow-visible'>
        <div
          className={classMerge(
            `flex w-full items-center justify-between border-b p-4 ${borderClass} ${textColor} ${headerBackground}`,
            className,
          )}
        >
          {headerRow.map((headerText, index) => {
            return (
              <div
                className={getColumnWidth(index, totalColumns)}
                key={`header-row-${headerText}`}
              >
                <Text
                  className={classMerge(
                    `${index === headerRow.length - 1 ? 'pr-4' : ''}`,
                    textAlignment,
                    textColor,
                  )}
                  styleName='p-small-strong'
                  value={headerText}
                />
              </div>
            )
          })}
        </div>

        <div className='max-h-[400px] overflow-visible md:overflow-auto'>
          {rows.map((row, rowIndex) => (
            <div
              className={classMerge(
                `flex w-full justify-between p-4`,
                className,
              )}
              key={`regular-row-${rowIndex}`}
            >
              {row.map((item, columnIndex) => {
                return (
                  <div
                    className={classMerge(
                      getColumnWidth(columnIndex, totalColumns),
                      columnClassName,
                    )}
                    key={`item-${columnIndex}`}
                  >
                    <Text
                      className={classMerge(
                        clampContent ? 'line-clamp-3' : '',
                        columnIndex === headerRow.length - 1 ? 'pr-4' : '',
                        textAlignment,
                        'whitespace-pre-line',
                      )}
                      value={item}
                    />
                  </div>
                )
              })}
            </div>
          ))}
        </div>
      </div>
    </div>
  )
}
